// import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
// import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles';
// import { CssBaseline } from '@mui/material';
// import { themeCreator } from '../theme/base';

// interface ThemeContextType {
//     theme: string;
//     toggleTheme: () => void;
//     setTheme: (theme: string) => void;
// }

// const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

// interface ThemeProviderProps {
//     children: ReactNode;
// }

// export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
//     const [theme, setThemeState] = useState<string>(() => {
//         // Get theme from localStorage or default to light
//         const savedTheme = localStorage.getItem('theme');
//         return savedTheme || 'PureLightTheme';
//     });

//     const toggleTheme = () => {
//         const newTheme = theme === 'PureLightTheme' ? 'PureDarkTheme' : 'PureLightTheme';
//         setThemeState(newTheme);
//         localStorage.setItem('theme', newTheme);
//     };

//     const setTheme = (newTheme: string) => {
//         setThemeState(newTheme);
//         localStorage.setItem('theme', newTheme);
//     };

//     // Listen for system theme changes
//     useEffect(() => {
//         const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

//         const handleChange = (e: MediaQueryListEvent) => {
//             if (!localStorage.getItem('theme')) {
//                 // Only auto-switch if user hasn't manually set a theme
//                 const newTheme = e.matches ? 'PureDarkTheme' : 'PureLightTheme';
//                 setThemeState(newTheme);
//             }
//         };

//         mediaQuery.addEventListener('change', handleChange);
//         return () => mediaQuery.removeEventListener('change', handleChange);
//     }, []);

//     let currentTheme;
//     try {
//         currentTheme = themeCreator(theme);
//         console.log('Theme created successfully:', theme, currentTheme);
//     } catch (error) {
//         console.error('Error creating theme:', error);
//         // Fallback to a basic Material-UI theme
//         currentTheme = createTheme();
//         console.log('Using fallback theme');
//     }

//     return (
//         <ThemeContext.Provider value={{ theme, toggleTheme, setTheme }}>
//             <MuiThemeProvider theme={currentTheme}>
//                 <CssBaseline />
//                 {children}
//             </MuiThemeProvider>
//         </ThemeContext.Provider>
//     );
// };

// export const useTheme = (): ThemeContextType => {
//     const context = useContext(ThemeContext);
//     if (context === undefined) {
//         throw new Error('useTheme must be used within a ThemeProvider');
//     }
//     return context;
// };


import React, { createContext, useContext, ReactNode } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { themeCreator } from '../theme/base';

interface ThemeContextType {
  theme: string;
  toggleTheme: () => void; // still expose but does nothing
  setTheme: (theme: string) => void; // still expose but locks to light
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

interface ThemeProviderProps {
  children: ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  // Always light
  const theme = 'PureLightTheme';

  const toggleTheme = () => {
    console.log("Dark mode disabled. Always using PureLightTheme.");
  };

  const setTheme = (_theme: string) => {
    console.log("Theme switching disabled. Always using PureLightTheme.");
  };

  let currentTheme;
  try {
    currentTheme = themeCreator(theme);
    console.log('Theme created successfully:', theme, currentTheme);
  } catch (error) {
    console.error('Error creating theme:', error);
    currentTheme = themeCreator('PureLightTheme'); // fallback
  }

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, setTheme }}>
      <MuiThemeProvider theme={currentTheme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
};

export const useTheme = (): ThemeContextType => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
